// extracted by mini-css-extract-plugin
module.exports = {"container":"_1kAPwtBw","wrapper":"_2CXcNVsL","hirewellTextBlock":"_7aLZXdR-","hirewellText":"_1VVMPLTK","learnMore":"_1t4J5UlZ"};
    if(module.hot) {
      // 1746735767752
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  